var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-bar"},[_c('ul',_vm._l((_vm.tabList),function(item,index){return _c('li',{key:index,class:_vm.currentId == item.id ? 'active': '',on:{"click":function($event){return _vm.goDetail(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }